(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("luna-menu"));
	else if(typeof define === 'function' && define.amd)
		define(["luna-menu"], factory);
	else if(typeof exports === 'object')
		exports["LunaDataGrid"] = factory(require("luna-menu"));
	else
		root["LunaDataGrid"] = factory(root["LunaMenu"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__121__) {
return 